
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleRack, updateRackEntry } from '../../Store/PHPSlice/Rack';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const RackEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        rackId: parseInt(Id),
        rackNm: '',
        userId: userdata?.ID,
        locId: ''
    });
    const dispatch = useDispatch();
    const singleRack = useSelector((state) => state.RackData.singleRack || { data: [] });
    const loclist = useSelector(selectlocationdata);
    useEffect(() => {
        dispatch(fetchSingleRack(Id));
        dispatch(fetchLocationData());
    }, [dispatch]);

    useEffect(() => {
        if (singleRack.data.length > 0) {
            const item = singleRack.data[0];
            setFormData({
                ...formData,
                rackNm: item.rackNm,
                locId: item.locId
            });
        }
    }, [singleRack]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log(formData);


        dispatch(updateRackEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Rack Updated Successful");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const dropdownFirm = [
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.firmId
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Rack Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                }

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='rackNm' >Rack Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='rackNm'
                                                    name='rackNm'
                                                    value={formData.rackNm}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default RackEdit;
